import { QUOTE_STEPS, ACTIONS, EXT_QUOTE_ACTIONS, YES_NO } from "../AppConstants";
import { IAppState, appInitialState } from "../state/interfaces";
import * as _ from 'lodash';

//const initialState = {
//    zipCode: "",
//    coverageConfigCode: "",
//    currentStep: QUOTE_STEPS.START,
//    vehicles: [],
//    drivers: [],
//    currentInsurance: null,
//    contactInfo: null,
//    paymentChoice: null
//}

interface IAction {
    type: string
}

export function rootReducer(state: IAppState | undefined, action: any) {
    if (typeof state === 'undefined') {
        //return initialState;
        return appInitialState;
    }

    switch (action.type) {
        case ACTIONS.RESET_APP_STATE:
            return appInitialState;
        case ACTIONS.SET_CARRIER_CUSTOMIZATION:
            return { ...state, carrierCustomization: action.carrierCustomization };
        case ACTIONS.QUOTE_STARTED:
            return { ...state, zipCode: action.zipCode, stateCode: action.stateCode }
        case ACTIONS.CHANGE_ZIP:
            //const drivers = [...state.drivers];
            //for (let i = 0; i < drivers.length; i++) {
            //    let driver = drivers[i];
            //    if (null !== driver.address) {
            //        driver.address.city = action.city;
            //        driver.address.stateCode = action.stateCode;
            //        driver.address.zipCode = action.zipCode;
            //        driver.address.street = "";
            //    }

            //    driver.incidents = [];
            //    driver.accidentsViolations = "";
            //    driver.gender = "";
            //}
            return { ...state, zipCode: action.zipCode, stateCode: action.stateCode,/* drivers, violationList: null, currentInsurance: null*/ }
        case ACTIONS.QUOTE_STEP_CHANGED:
            return { ...state, currentStep: action.currentStep }
        case ACTIONS.QUOTE_CREATED:
            return action.quote.vehicle
                ? { ...state, quoteUid: action.quote.uid, quoteId: action.quote.quoteId, vehicles: [action.quote.vehicle] }
                : { ...state, quoteUid: action.quote.uid, quoteId: action.quote.quoteId }
        case ACTIONS.SET_POST_QUOTE_STATE:
            return { ...state, stateCode: action.stateCode }
        case ACTIONS.SET_MAP_QUOTE_STATE:
            return { ...state, stateCode: action.stateCode }
        case ACTIONS.QUOTE_QUICK:
            return { ...state, vehicles: [...action.vehicles], drivers: [...action.drivers], coverageConfig: action.coverageConfig, discountOption: action.discounts, contactInfo: action.contactInfo, isNonOwners: action.isNonOwners, rateError: null };
        case ACTIONS.QUOTE_QUICK_UPDATED:
            return {
                ...state,
                vehicles: [...action.vehicles],
                drivers: [...action.drivers],
                coverageConfig: action.coverageConfig,
                contactInfo: action.contactInfo,
                isNonOwners: action.isNonOwners,
                rateError: null
            }
        case ACTIONS.UPDATE_VEHICLE:
            for (let i = 0; i < state.vehicles.length; i++) {
                if (state.vehicles[i].id === action.vehicle.id) {
                    const updatedVehicle = Object.assign({}, state.vehicles[i], action.vehicle);
                    state.vehicles[i] = updatedVehicle;
                    return state;
                }
            }
            state.vehicles.push(action.vehicle);
            return { ...state, vehicles: [...state.vehicles] };
        case ACTIONS.UPDATE_DRIVER:
            for (let i = 0; i < state.drivers.length; i++) {
                if (state.drivers[i].id === action.driver.id) {
                    const updatedDriver = Object.assign({}, state.drivers[i], action.driver);
                    state.drivers[i] = updatedDriver;
                    if (0 === i && updatedDriver.address && updatedDriver.address.zipCode) {
                        state.zipCode = updatedDriver.address.zipCode;
                    }
                    return state;
                }
            }
            state.drivers.push(action.driver);
            return { ...state, drivers: [...state.drivers] };
        case ACTIONS.UPDATE_INSURANCE:
            return { ...state, currentInsurance: action.currentInsurance }
        case ACTIONS.UPDATE_CONTACT_INFO:
            //state.contactInfo = action.contactInfo;
            return { ...state, contactInfo: action.contactInfo, rateError: null };
        case ACTIONS.SELECT_COVERAGE_CONFIG:
            return { ...state, coverageConfig: action.coverageConfig }
        case ACTIONS.PAYMENT_CHOICE_SELECTED:
            return { ...state, rate: action.rate, paymentChoice: action.paymentChoice, agenciesContactInfo: action.agenciesContactInfo, rateError: action.rateError }
        case ACTIONS.RTR_PAYMENT_CHOICE_SELECTED:
            return { ...state, rate: action.rate, paymentChoice: action.paymentChoice }
        case ACTIONS.LOAD_QUOTE:
            state.quoteUid = action.quote.data.uid;
            return { ...state, ...action.quote.data };
        case ACTIONS.BUY_NOW_QUOTE:
            state.quoteUid = action.quoteUid;
            return { ...state, quoteFromLiberate: true, quoteUid: action.quoteUid };
        case ACTIONS.LANDING_QUOTE:
            state.quoteUid = action.quote.uid;
            state.stateCode = action.quote.stateCode;
            state.currentPath = action.quote.currentPath;
            return { ...state, ...action.quote };
        case ACTIONS.FILL_EXTERNAL_QUOTE:
            return { ...state, externalQuote: action.quote };
        case ACTIONS.FILL_OFFLINE_DATA:
            return { ...state, appOfflineData: action.offlineData };
        case ACTIONS.FILL_RTR_QUOTE:
            return {
                ...state,
                externalQuote: action.quote,
                paymentChoice: { ...state.paymentChoice, firstPay: action.paymentChoice.downpaymentAmount, regularPay: action.paymentChoice.installmentAmount, motorclubFee: action.paymentChoice.motorclubFee }
            };
        case EXT_QUOTE_ACTIONS.UPDATE_VEHICLE:
            if (!state.externalQuote) return state;
            const vehicles = [...state.externalQuote.vehicles];
            
            for (let i = 0; i < vehicles.length; i++) {
                if (vehicles[i].id === action.vehicle.id) {
                    const updatedVehicle = Object.assign({}, vehicles[i], action.vehicle);
                    if (action.hasOwnProperty("vehicleChanged")) {
                        updatedVehicle.changed = action.vehicleChanged;
                    }
                    vehicles[i] = updatedVehicle;
                    if (action.hasOwnProperty("quoteRerated")) {
                        return { ...state, externalQuote: { ...state.externalQuote, vehicles, coverages: null, reRated: action.quoteRerated } };
                    }
                    return { ...state, externalQuote: { ...state.externalQuote, vehicles, coverages: null } };
                }
            }
            return state;
        case EXT_QUOTE_ACTIONS.UPDATE_COVERAGES: {
            if (!state.externalQuote) return state;
            const _coverages = action.coverageConfig;
            _coverages.changed = action.coveragesChanged;
            return { ...state, externalQuote: { ...state.externalQuote, coverages: _coverages } }
        }
        case EXT_QUOTE_ACTIONS.UPDATE_QUOTE_QUESTIONS: {
            if (!state.externalQuote) return state;
            const _questions = action.questions;
            return { ...state, externalQuote: { ...state.externalQuote, questions: _questions } }
        }
        case EXT_QUOTE_ACTIONS.UPDATE_APPLICANT_ADDRESS: {
            if (!state.externalQuote) return state;
            for (let i = 0; i < state.externalQuote.drivers.length; i++) {
                const updatedDriver = Object.assign({}, state.externalQuote.drivers[i], action.driver);
                updatedDriver.address = action.address;
                state.externalQuote.drivers[i] = updatedDriver;
                if (i === 0) {
                    const updatedInsured = state.externalQuote.insured;
                    updatedInsured.firstName = updatedDriver.firstName;
                    updatedInsured.lastName = updatedDriver.lastName;
                    updatedInsured.address = action.address;
                    state.externalQuote.insured = updatedInsured;
                }
            }

            for (let i = 0; i < state.externalQuote.vehicles.length; i++) {
                const updatedVehicle = Object.assign({}, state.externalQuote.vehicles[i], action.vehicle);
                if (updatedVehicle.garagingAddress.street === '') {
                    updatedVehicle.garagingAddress = action.address;
                    state.externalQuote.vehicles[i] = updatedVehicle;
                }
            }

            const updatedContactInfo = state.contactInfo;
            updatedContactInfo.email = action.contactInfo.email;
            updatedContactInfo.phone = action.contactInfo.phone;
            state.contactInfo = updatedContactInfo;

            return state;
        }
        case EXT_QUOTE_ACTIONS.UPDATE_DRIVER:
            if (!state.externalQuote) return state;
            for (let i = 0; i < state.externalQuote.drivers.length; i++) {
                if (state.externalQuote.drivers[i].id === action.driver.id) {
                    const updatedDriver = Object.assign({}, state.externalQuote.drivers[i], action.driver);
                    updatedDriver.driverChanged = action.driverChanged;
                    state.externalQuote.drivers[i] = updatedDriver;

                    if (i === 0) {
                        const updatedInsured = state.externalQuote.insured;
                        updatedInsured.firstName = updatedDriver.firstName;
                        updatedInsured.lastName = updatedDriver.lastName;
                        state.externalQuote.insured = updatedInsured;
                    }

                    return { ...state, externalQuote: { ...state.externalQuote, drivers: [...state.externalQuote.drivers], reRated: action.quoteRerated } };
                }
            }
            return state;
        case EXT_QUOTE_ACTIONS.UPDATE_AGREEMENT:
            state.contactInfo = action.contactInfo;
            if (!state.externalQuote) return state;
            let { externalQuote } = { ...state };
            if (!externalQuote) return;
            externalQuote.agreement = action.agreement;
            return {
                ...state,
                externalQuote: { ...state.externalQuote, esignatureForms: action.esignatureForms }
            };
        case EXT_QUOTE_ACTIONS.RESET_AGREEMENT:
            if (!state.externalQuote) return state;

            state.externalQuote.agreement = {
                agreeDrivers: false,
                agreeEmailCorrect: false,
                agreeOtherDrivers: false,
                agreePolicyEffDate: false,
                agreeUMDecline: false
                //agreeSalvage: false,
                //agreeVehicles: false
            };

            return state;
        case EXT_QUOTE_ACTIONS.UPDATE_VIOLATIONS:
            if (!state.externalQuote) return state;
            return { ...state, externalQuote: { ...state.externalQuote, mvrResult: action.mvrResult } };
        case EXT_QUOTE_ACTIONS.RERATE_QUOTE:
            if (!state.externalQuote) return state;
            return {
                ...state,
                paymentChoice: { ...state.paymentChoice, firstPay: action.data.payment.downpaymentAmount, regularPay: action.data.payment.installmentAmount, motorclubFee: action.data.payment.motorclubFee },
                externalQuote: { ...state.externalQuote, vehicles: action.data.quote.vehicles, reRated: true, hasMvrViolations: action.data.hasMvrViolations, hasAdditionalDrivers: action.data.hasAdditionalDrivers }
            };
        case EXT_QUOTE_ACTIONS.RESET_CHANGED_FLAGS: {
            if (!state.externalQuote) return state;
            if (state.externalQuote.coverages) {
                state.externalQuote.coverages.changed = false;
            }
            state.externalQuote.vehicles.forEach(x => x.changed = false);
            state.externalQuote.drivers.forEach(x => x.driverChanged = false);
            return state;
        }
        case EXT_QUOTE_ACTIONS.RESET_QUOTE_EFF_DATE:

            if (!state.externalQuote) return state;

            if (state.paymentChoice) {
                state.paymentChoice.firstPay = action.data.payment.downpaymentAmount;
                state.paymentChoice.regularPay = action.data.payment.installmentAmount;
                state.paymentChoice.motorclubFee = action.data.payment.motorclubFee;
            }

            if (state.currentInsurance) {
                state.currentInsurance.effectiveDate = action.data.mappedQuote.effectiveDate;
            }

            state.externalQuote.effectiveDate = action.data.mappedQuote.effectiveDate;
            state.externalQuote.effectiveDatetimeStamp = action.effectiveDatetimeStamp;
            state.externalQuote.installmentDueDate = action.data.mappedQuote.installmentDueDate;
            state.externalQuote.reRated = true;

            return state;
        case EXT_QUOTE_ACTIONS.RESET_QUOTE_TIME_STAMP_EFF_DATE:

            if (!state.externalQuote) return state;

            state.externalQuote.effectiveDatetimeStamp = action.effectiveDatetimeStamp;

            return state;
        case EXT_QUOTE_ACTIONS.RELOAD_QUOTE_PMT_INFO: {
            if (!state.externalQuote) return state;

            const vehicles = [...action.data.vehicles];

            if (state.paymentChoice?.firstPay !== action.data.downpaymentAmount) {
                const changedVehicles = state.externalQuote.vehicles.filter(x => x.changed);
                for (let i = 0; i < vehicles.length; i++) {
                    if (changedVehicles.some(x => x.id === vehicles[i].id)) {
                        const updatedVehicle = Object.assign({}, vehicles[i]);
                        updatedVehicle.changed = true;
                        vehicles[i] = updatedVehicle;
                    }
                }
            }

            return {
                ...state,
                paymentChoice: { ...state.paymentChoice, firstPay: action.data.downpaymentAmount, regularPay: action.data.installmentAmount, motorclubFee: action.data.motorclubFee },
                externalQuote: { ...state.externalQuote, vehicles: vehicles, reRated: action.data.quoteRerated }
            };
        }
        case EXT_QUOTE_ACTIONS.BIND_QUOTE:
            if (!state.externalQuote) return state;
            return {
                ...state,
                externalQuote: { ...state.externalQuote, bindResult: action.bindResult }
            };
        case EXT_QUOTE_ACTIONS.UPDATE_DOCUMENTS:
            if (!state.externalQuote) return state;
            return {
                ...state,
                externalQuote: {
                    ...state.externalQuote, bindResult: { ...state.externalQuote.bindResult, documents: action.documents }
                }
            };
        case EXT_QUOTE_ACTIONS.UPDATE_PAYMENT_PLAN:
            if (!state.externalQuote) return state;
            return {
                ...state,
                externalQuote: { ...state.externalQuote, paymentPlanCode: action.paymentPlanCode }
            };
        case EXT_QUOTE_ACTIONS.FILL_E_SIGNATURES:
            {
                if (!state.externalQuote) return state;
                let { externalQuote } = { ...state };
                if (!externalQuote) return;
                return {
                    ...state,
                    externalQuote: { ...state.externalQuote, esignatureForms: action.esignatureForms }
                };
            }
        case ACTIONS.LOAD_CONTACT_INFO:
            return { ...state, contactInfo: action.contactInfo };
        case ACTIONS.UPDATE_VIOLATION_LIST:
            return { ...state, violationList: action.violationList }
        default:
            return state;
    }
}